import Accordion from "components/blocks/Accordion";
import AccordionItem from "components/blocks/Accordion/AccordionItem";
import FormInput from "components/blocks/FormInput";
import { useTranslation } from "react-i18next";
import {BackendServices} from "../../../../../../../../services";
import {useQuery} from "../../../../../../../../hooks/useQuery";
import {SettingKeys} from "../../../../../../../../services/settingService/models/SettingTypes";
import {
    CourseOrderLocalItemResult, UpdateCourseOrderAmountRequest,
    UpdateCourseOrderISBNRequest
} from "../../../../../../../../services/courseOrder/models/CourseOrderType";
import {useEffect, useState} from "react";
import FileUploadWithPreview, {SelectedFilesType} from "../../../../../../../../components/blocks/FileUploadWithPreview";
import {CourseLocalItemResult} from "../../../../../../../../services/courseService/models/CourseType";


const EditRewards = ({ order ,submitRef,course }: { order: CourseOrderLocalItemResult | null , submitRef:any; course?: CourseLocalItemResult | null; }) => {
    const { t } = useTranslation("Orders");
    const [authorAmountState , setAuthorAmountState ] = useState<UpdateCourseOrderAmountRequest>({
      authorAmount :order?.authorAmount, 
        authorAmountFiles: order?.authorAmountFiles?.map(w=>w.id)??[],

    })
    const [error, setError] = useState<string | undefined>(undefined);
    const [authorAmountFiles, setAuthorAmountFiles] = useState<SelectedFilesType[]>([]);
    const { data:examiner } = useQuery({
        queryFn: async () => {
            return await BackendServices.settingsService.getSettingValue(SettingKeys.ExaminerRewards);
        },
    });
    const { data:referee } = useQuery({
        queryFn: async () => {
            return await BackendServices.settingsService.getSettingValue(SettingKeys.RefereeRewards);
        },
    });

    useEffect(() => {
        setAuthorAmountState({
            authorAmount :order?.authorAmount??order?.scientificClassification?.fromValue??0,
            authorAmountFiles: order?.authorAmountFiles?.map(w=>w.id)??[],
        });

        setAuthorAmountFiles( order?.authorAmountFiles?.map((file) => ({
            file: new File([], file.name ?? ""),
            fileName: file.name ?? "",
            uuid: file.id.toString(),
            size: file.size,
        }))??[]);
    }, [order,course]);
    
    
    useEffect(() => {
        
        submitRef.current = {
            globalSubmit:async (actionName: string,openTask: any,notes?:string ) :Promise<number>=>{
                if(actionName ==="Complete" || actionName==="CompleteOrder")
                {
                    let from  =order?.scientificClassification?.fromValue ??0;
                    let to  =order?.scientificClassification?.toValue ??0;
                    let amount = authorAmountState?.authorAmount ??0;
                    if(amount < from || amount > to)
                    {

                        return -1;
                    }
                 
                    const res= await BackendServices.courseOrderService.updateCourseOrderAmount(order?.id??0, authorAmountState);
                    if(res.hasError)
                    {
                        console.log(res.description);
                    }
                    return 0;
                }
                return 0;
            }
        }
    },[authorAmountState])

    return (
        <Accordion>
            <AccordionItem initiallyOpen title={t("rewards")} elementId={"rewards"}>
                <div className="d-flex gap-2 flex-wrap">
                    <FormInput
                        label={t("authorRewardAmount") + ` (${order?.scientificClassification?.fromValue??0} - ${order?.scientificClassification?.toValue??0})`}
                        type={"number"}
                        error={error}
                        min={order?.scientificClassification?.fromValue??0}
                        max={order?.scientificClassification?.toValue??0}
                        leftElement={<span className="text-primary">{t("ryal")}</span>}
                        onChange={(e) => {
                            let from  =order?.scientificClassification?.fromValue ??0;
                            let to  =order?.scientificClassification?.toValue ??0;
                            if(+e.target.value < from || +e.target.value > to) {
                                setError(t("authorRewardAmountError"));
                            }
                            else {
                                setError(undefined);
                            }
                              setAuthorAmountState({...authorAmountState, authorAmount: +e.target.value})
                        }
                    }
                        value={authorAmountState?.authorAmount}
                    />
                    { order?.courseOrderEvaluation?.evaluationFormId &&  <FormInput
                        label={t("examinerRewardAmount")}
                        disabled
                        leftElement={<span className="text-primary">{t("ryal")}</span>}
                        value={examiner?.value}
                    />}

                    { order?.courseOrderEvaluation?.refereeEvaluationFormId &&    <FormInput
                        label={t("judgeRewardAmount")}
                        disabled
                        leftElement={<span className="text-primary">{t("ryal")}</span>}
                        value={referee?.value}
                    />}
                </div>
                <div className="pt-4">
                    <h6 className="fw-bold">{t("attachments")}</h6>
                    <div className="d-flex gap-3 mt-2 ">
                        <FileUploadWithPreview
                            label={t("uploadCompleteFile")}
                            files={authorAmountFiles}
                            setFiles={setAuthorAmountFiles}
                            onChange={(files) => {
                                setAuthorAmountState({... authorAmountState, authorAmountFiles: files.map((x) => x.uuid)});
                            }}
                        />
                    </div>
                </div>

                <div className="divider mt-4 "></div>
            </AccordionItem>
        </Accordion>
    );
};

export default EditRewards;
